"use client";

import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
const credentials = [{
  id: "react",
  name: "React.js",
  description: "Building high-performance, component-driven user interfaces for modern web applications.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_react_logo.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_react_logo.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_react_logo.png-wvc-sizes"
}, {
  id: "node",
  name: "Node.js",
  description: "Scalable server-side environments for real-time data processing and robust backends.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_node_logo.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_node_logo.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_node_logo.png-wvc-sizes"
}, {
  id: "aws",
  name: "AWS Cloud",
  description: "Enterprise-grade cloud infrastructure for global scalability and high availability.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_aws_logo.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_aws_logo.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_aws_logo.png-wvc-sizes"
}, {
  id: "docker",
  name: "Docker",
  description: "Containerization for consistent deployment across development and production environments.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_docker_logo.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_docker_logo.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_docker_logo.png-wvc-sizes"
}, {
  id: "kubernetes",
  name: "Kubernetes",
  description: "Orchestrating complex microservices architectures with automated scaling and management.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_k8s_logo.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_k8s_logo.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/tech_k8s_logo.png-wvc-sizes"
}];
export default function IndustryCredentials() {
  return;
}